



import { useState, useEffect, useMemo, useCallback, Fragment, lazy, Suspense } from "react";
import { _apiMode, getActingTenantId, setActingTenantId, api, apiLogin, apiVerifyTotp, apiGet, getMe, ToastContainer, EmptyState, LoadingSkeleton, C, F, M, DEPTS, EMPLOYEES, MRP, MZP, DEMO_ENABLED, S, useMyTasks, setApiMode, getNavRecent, pushNavRecent, getNavFavorites, toggleNavFavorite } from "./shared";
const FnoReportingScreen = lazy(() => import("./screens/FnoReportingScreen"));
const AnalyticsDashboardScreen = lazy(() => import("./screens/AnalyticsDashboardScreen"));
const AccrualJournalScreen = lazy(() => import("./screens/journals")); // R115 Этап 3
const GpdJournalScreen = lazy(() => import("./screens/journals").then(m => ({ default: m.GpdJournalScreen }))); // R116
const CorrectionJournalScreen = lazy(() => import("./screens/journals").then(m => ({ default: m.CorrectionJournalScreen })));
const HrJournalScreen = lazy(() => import("./screens/journals").then(m => ({ default: m.HrJournalScreen })));
const AbsenceJournalScreen = lazy(() => import("./screens/journals").then(m => ({ default: m.AbsenceJournalScreen })));
const IpnRecalculationScreen = lazy(() => import("./screens/corrections").then(m => ({ default: m.IpnRecalculationScreen })));
const IpnRefundScreen = lazy(() => import("./screens/corrections").then(m => ({ default: m.IpnRefundScreen })));
const InsuranceRecalcScreen = lazy(() => import("./screens/corrections").then(m => ({ default: m.InsuranceRecalcScreen })));
const ContributionPenaltyScreen = lazy(() => import("./screens/corrections").then(m => ({ default: m.ContributionPenaltyScreen })));
const GuardianPaymentScreen = lazy(() => import("./screens/corrections").then(m => ({ default: m.GuardianPaymentScreen })));
const AvgEarningsTransferScreen = lazy(() => import("./screens/corrections").then(m => ({ default: m.AvgEarningsTransferScreen })));
const AbsenceRecordScreen = lazy(() => import("./screens/corrections").then(m => ({ default: m.AbsenceRecordScreen })));
const TimeOffInLieuScreen = lazy(() => import("./screens/corrections").then(m => ({ default: m.TimeOffInLieuScreen })));
const IncomingEarningCertScreen = lazy(() => import("./screens/corrections").then(m => ({ default: m.IncomingEarningCertScreen })));
const OutgoingEarningCertScreen = lazy(() => import("./screens/corrections").then(m => ({ default: m.OutgoingEarningCertScreen })));
const OccSafetyScreen = lazy(() => import("./screens/corrections").then(m => ({ default: m.OccSafetyScreen })));
const BenefitsScreen = lazy(() => import("./screens/corrections").then(m => ({ default: m.BenefitsScreen })));
const KpiBonusScreen = lazy(() => import("./screens/corrections").then(m => ({ default: m.KpiBonusScreen })));
const AdvanceScreen = lazy(() => import("./screens/corrections").then(m => ({ default: m.AdvanceScreen })));
const PersonalAccountScreen = lazy(() => import("./screens/corrections").then(m => ({ default: m.PersonalAccountScreen })));
const ReconciliationScreen = lazy(() => import("./screens/corrections").then(m => ({ default: m.ReconciliationScreen })));
const StornoScreen = lazy(() => import("./screens/documents").then(m => ({ default: m.StornoScreen })));
const VacationReserveScreen = lazy(() => import("./screens/documents").then(m => ({ default: m.VacationReserveScreen })));
const ReinstatementScreen = lazy(() => import("./screens/documents").then(m => ({ default: m.ReinstatementScreen })));
const GpdContractScreen = lazy(() => import("./screens/documents").then(m => ({ default: m.GpdContractScreen })));
const ContractSuspensionScreen = lazy(() => import("./screens/documents").then(m => ({ default: m.ContractSuspensionScreen })));
const VacationScheduleScreen = lazy(() => import("./screens/documents").then(m => ({ default: m.VacationScheduleScreen })));
const AuthorContractScreen = lazy(() => import("./screens/documents").then(m => ({ default: m.AuthorContractScreen })));
const WeekendHolidayWorkScreen = lazy(() => import("./screens/documents").then(m => ({ default: m.WeekendHolidayWorkScreen })));
const SecondaryPositionScreen = lazy(() => import("./screens/documents").then(m => ({ default: m.SecondaryPositionScreen })));
const ChildcareLeaveScreen = lazy(() => import("./screens/documents").then(m => ({ default: m.ChildcareLeaveScreen })));
const UnpaidLeaveScreen = lazy(() => import("./screens/documents").then(m => ({ default: m.UnpaidLeaveScreen })));
const OneTimeAccrualScreen = lazy(() => import("./screens/documents").then(m => ({ default: m.OneTimeAccrualScreen })));
const PrizeGiftScreen = lazy(() => import("./screens/documents").then(m => ({ default: m.PrizeGiftScreen })));
const PaymentStatementScreen = lazy(() => import("./screens/documents").then(m => ({ default: m.PaymentStatementScreen })));
const DeductionsScreen = lazy(() => import("./screens/accruals").then(m => ({ default: m.DeductionsScreen })));
const MaterialAidScreen = lazy(() => import("./screens/accruals").then(m => ({ default: m.MaterialAidScreen })));
const NaturalIncomeScreen = lazy(() => import("./screens/accruals").then(m => ({ default: m.NaturalIncomeScreen })));
const DividendPaymentScreen = lazy(() => import("./screens/accruals").then(m => ({ default: m.DividendPaymentScreen })));
const BonusPaymentScreen = lazy(() => import("./screens/accruals").then(m => ({ default: m.BonusPaymentScreen })));
const DepositedSalaryScreen = lazy(() => import("./screens/accruals").then(m => ({ default: m.DepositedSalaryScreen })));
const PlannedAccrualChangeScreen = lazy(() => import("./screens/accruals").then(m => ({ default: m.PlannedAccrualChangeScreen })));
const SalaryIndexationScreen = lazy(() => import("./screens/accruals").then(m => ({ default: m.SalaryIndexationScreen })));
const QualificationGradeChangeScreen = lazy(() => import("./screens/accruals").then(m => ({ default: m.QualificationGradeChangeScreen })));
const DowntimeScreen = lazy(() => import("./screens/accruals").then(m => ({ default: m.DowntimeScreen })));
const SalaryDelayCompensationScreen = lazy(() => import("./screens/accruals").then(m => ({ default: m.SalaryDelayCompensationScreen })));
const TaxPaymentScreen = lazy(() => import("./screens/accruals").then(m => ({ default: m.TaxPaymentScreen })));
const ContractExtensionScreen = lazy(() => import("./screens/accruals").then(m => ({ default: m.ContractExtensionScreen })));
const TrainingScreen = lazy(() => import("./screens/hr").then(m => ({ default: m.TrainingScreen })));
const PerformanceScreen = lazy(() => import("./screens/hr").then(m => ({ default: m.PerformanceScreen })));
const VacationScreen = lazy(() => import("./screens/hr").then(m => ({ default: m.VacationScreen })));
const RoundingRulesScreen = lazy(() => import("./screens/hr").then(m => ({ default: m.RoundingRulesScreen })));
const ReferenceRatesScreen = lazy(() => import("./screens/hr").then(m => ({ default: m.ReferenceRatesScreen })));
const GlLedgerScreen = lazy(() => import("./screens/hr").then(m => ({ default: m.GlLedgerScreen })));
const CalendarScreen = lazy(() => import("./screens/hr").then(m => ({ default: m.CalendarScreen })));
const DepartmentsTreeScreen = lazy(() => import("./screens/staffing").then(m => ({ default: m.DepartmentsTreeScreen })));
const WorkLocationScreen = lazy(() => import("./screens/staffing").then(m => ({ default: m.WorkLocationScreen })));
const StaffingApprovalScreen = lazy(() => import("./screens/staffing").then(m => ({ default: m.StaffingApprovalScreen })));
const WorkExperienceScreen = lazy(() => import("./screens/staffing").then(m => ({ default: m.WorkExperienceScreen })));
const AttestationScreen = lazy(() => import("./screens/staffing").then(m => ({ default: m.AttestationScreen })));
const InitialStaffingAssignmentScreen = lazy(() => import("./screens/staffing").then(m => ({ default: m.InitialStaffingAssignmentScreen })));
const PayrollDataInputScreen = lazy(() => import("./screens/staffing").then(m => ({ default: m.PayrollDataInputScreen })));
const WorkplaceChangeScreen = lazy(() => import("./screens/staffing").then(m => ({ default: m.WorkplaceChangeScreen })));
const OnboardingWizardScreen = lazy(() => import("./screens/staffing").then(m => ({ default: m.OnboardingWizardScreen })));
const StaffGradeScreen = lazy(() => import("./screens/operations").then(m => ({ default: m.StaffGradeScreen })));
const StaffScheduleScreen = lazy(() => import("./screens/operations").then(m => ({ default: m.StaffScheduleScreen })));
const RecruitingScreen = lazy(() => import("./screens/operations").then(m => ({ default: m.RecruitingScreen })));
const EssScreen = lazy(() => import("./screens/operations").then(m => ({ default: m.EssScreen })));
const TimesheetScreen = lazy(() => import("./screens/operations").then(m => ({ default: m.TimesheetScreen })));
const SickLeaveScreen = lazy(() => import("./screens/operations").then(m => ({ default: m.SickLeaveScreen })));
const WorkflowScreen = lazy(() => import("./screens/operations").then(m => ({ default: m.WorkflowScreen })));
const TripsScreen = lazy(() => import("./screens/operations").then(m => ({ default: m.TripsScreen })));
const OneCSyncScreen = lazy(() => import("./screens/operations").then(m => ({ default: m.OneCSyncScreen })));
const HrHistoryScreen = lazy(() => import("./screens/operations").then(m => ({ default: m.HrHistoryScreen })));
const LoansScreen = lazy(() => import("./screens/operations").then(m => ({ default: m.LoansScreen })));
const EmployeesScreen = lazy(() => import("./screens/core").then(m => ({ default: m.EmployeesScreen })));
const PayrollRunScreen = lazy(() => import("./screens/core").then(m => ({ default: m.PayrollRunScreen })));
const PayslipScreen = lazy(() => import("./screens/core").then(m => ({ default: m.PayslipScreen })));

function DashboardScreen({ setPage, canSee = () => true, navRecent = [], navFavs = [], toggleFav }) {
  const [stats, setStats] = useState(null);
  const [deptStats, setDeptStats] = useState([]);
  const [periodLabel, setPeriodLabel] = useState("");
  const [loading, setLoading] = useState(true);
  // §8.1-B виджет «Мои задачи» (Workday Inbox / SAP To-Do) — общий источник с колокольчиком (useMyTasks)
  const tasks = useMyTasks(_apiMode);

  // §8.1-C ролевые быстрые действия (SAP/Workday role-based home) — по permissions из JWT.
  const me = _apiMode ? getMe() : null;
  const isAdmin = !!me?.roles?.includes("admin");
  const can = p => isAdmin || (me?.permissions || []).includes(p);
  const quickActions = [
    can("payroll.calculate") && { icon:"🧮", label:"Расчёт ЗП",          page:"payroll" },
    can("workflow.approve")  && { icon:"✅", label:"Согласования",        page:"workflow" },
    can("timesheet.edit")    && { icon:"📋", label:"Табель",              page:"timesheet" },
    can("employee.create")   && { icon:"➕", label:"Добавить сотрудника", page:"employees" },
    can("reports.read")      && { icon:"📄", label:"Отчёты ФНО",          page:"fnoReporting" },
    can("analytics.read")    && { icon:"📈", label:"Аналитика",           page:"analytics" },
  ].filter(Boolean).slice(0, 6);

  const months = ["январь","февраль","март","апрель","май","июнь","июль","август","сентябрь","октябрь","ноябрь","декабрь"];
  useEffect(() => {
    let cancelled = false;
    // §5.1 ERP-аудит: в demo (нет API) Dashboard раньше показывал «0 активных · live данные»
    // (пустой, но подписан live → вводит в заблуждение). Теперь — агрегаты из demo-справочника
    // ТОО (DEPTS head/fot) + честная подпись «демо-данные». Прод (API) не затронут.
    if (!_apiMode) {
      // demo: агрегаты строим из СПИСКА сотрудников (EMPLOYEES), а не из штатных голов
      // DEPTS.head — иначе Dashboard показывал 23 (сумма штата), а экран «Сотрудники» — 12
      // (факт). На демо читалось как расхождение; теперь оба = 12.
      const byDept = {};
      DEPTS.forEach(d => { byDept[d.name] = { name: d.name, head: 0, fot: 0 }; });
      EMPLOYEES.forEach(e => { const b = byDept[e.dept]; if (b) { b.head += 1; b.fot += e.salary; } });
      const deptList = Object.values(byDept).filter(d => d.head > 0).sort((a, b) => b.fot - a.fot);
      const totalHead = deptList.reduce((s, d) => s + d.head, 0);
      const totalFot = deptList.reduce((s, d) => s + d.fot, 0);
      const now = new Date();
      setPeriodLabel(`${months[now.getMonth()]} ${now.getFullYear()}`);
      setStats({ totalHead, totalFot, avgSalary: totalHead > 0 ? Math.round(totalFot / totalHead) : 0, system: null, version: "demo", demo: true });
      setDeptStats(deptList);
      setLoading(false);
      return;
    }
    (async () => {
      try {
        const [health, headcount] = await Promise.all([
          apiGet("/health").catch(() => null),
          apiGet("/employees/headcount").catch(() => null),
        ]);
        if (cancelled) return;

        // Серверный агрегат по ВСЕМ активным сотрудникам (groupBy, без капа пагинации):
        // раньше Dashboard тянул /employees?limit=500 (бэк капит до 200) и считал клиентом,
        // из-за чего у тенанта >200 чел численность/ФОТ занижались. Теперь — точно на любом масштабе.
        const hcArr = Array.isArray(headcount) ? headcount : (headcount?.items || headcount?.data || []);
        const deptList = hcArr
          .map(d => ({ name: d.departmentName || "Без подразделения", head: Number(d.count || 0), fot: Number(d.fot || 0) }))
          .sort((a, b) => b.fot - a.fot);
        const totalHead = deptList.reduce((s, d) => s + d.head, 0);
        const totalFot = deptList.reduce((s, d) => s + d.fot, 0);
        const avgSalary = totalHead > 0 ? Math.round(totalFot / totalHead) : 0;

        const now = new Date();
        setPeriodLabel(`${months[now.getMonth()]} ${now.getFullYear()}`);

        setStats({ totalHead, totalFot, avgSalary, system: health?.stats || null, version: health?.version || "—" });
        setDeptStats(deptList);
      } catch (err) {
        console.warn("Dashboard load failed", err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  if (loading || !stats) {
    return (<div><div style={S.pageTitle}>Сводка</div><LoadingSkeleton rows={6} cols={4} /></div>);
  }

  const { totalHead, totalFot, avgSalary, system, version, demo } = stats;
  const maxFot = Math.max(1, ...deptStats.map(d => d.fot));

  // R114 §nav-IA Этап 2 (лаунчпад): хелперы плиток разделов и чипов.
  const plural = (n, one, few, many) => { const m10 = n % 10, m100 = n % 100; return m10 === 1 && m100 !== 11 ? one : ([2,3,4].includes(m10) && ![12,13,14].includes(m100)) ? few : many; };
  const sectionVisible = g => navGroupScreenIds(g).some(id => canSee(SCREEN_PERMS[id]));
  const sectionBadge = gid => {
    if (gid === "hr") return { n: totalHead, color: C.accent };
    if (gid === "staffing") return { n: deptStats.length, color: C.accent };
    if (gid === "payroll") { const n = (tasks?.failedRuns || 0) + (tasks?.overduePeriods || 0); return n > 0 ? { n, color: C.red } : null; }
    return null;
  };
  const chipStyle = color => ({ ...S.navBtnReset, width:"auto", display:"inline-flex", alignItems:"center", gap:6, background:C.bg3, border:`1px solid ${C.border}`, borderRadius:14, padding:"4px 11px", fontSize:11, color, cursor:"pointer" });
  const favList = (navFavs || []).filter(p => SCREENS[p] && canSee(SCREEN_PERMS[p]));
  const recentList = (navRecent || []).filter(p => SCREENS[p] && canSee(SCREEN_PERMS[p]));

  return (
    <div>
      <div style={S.pageTitle}>Сводка</div>
      <div style={S.pageSub}>{totalHead} активных сотрудников · {periodLabel} · {demo ? "демо-данные" : "данные из системы"}</div>

      {/* §8.1-C ролевые быстрые действия — набор по permissions пользователя (SAP/Workday role-based home) */}
      {quickActions.length > 0 && (
        <div style={{ display:"flex", gap:8, flexWrap:"wrap", marginBottom:16 }}>
          {quickActions.map((a,i) => (
            <button type="button" key={i} data-testid={`quick-${a.page}`} onClick={()=>setPage(a.page)}
              style={{ ...S.navBtnReset, ...S.btn(C.card), border:`1px solid ${C.border}`, fontSize:12, display:"inline-flex", alignItems:"center", gap:6, cursor:"pointer", padding:"8px 14px", width:"auto" }}>
              <span>{a.icon}</span><span>{a.label}</span>
            </button>
          ))}
        </div>
      )}

      {/* R114 §nav-IA Этап 2: лаунчпад — карта разделов (SAP Fiori tiles). Badge где данные уже есть. */}
      <div style={{ fontSize:11, fontWeight:700, textTransform:"uppercase", letterSpacing:"0.07em", color:C.muted, marginBottom:8 }}>Разделы</div>
      <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:10, marginBottom:18 }}>
        {NAV_GROUPS.filter(g => g.id !== "main" && sectionVisible(g)).map(g => {
          // только основные экраны раздела («дома»), без ссылок — честный счётчик
          const ids = [...new Set((g.folders || []).flatMap(f => f.items).filter(it => !navItemIsRef(it)).map(navItemId).filter(id => canSee(SCREEN_PERMS[id])))];
          const folderCount = (g.folders || []).filter(f => f.label).length;
          const badge = sectionBadge(g.id);
          return (
            <button type="button" key={g.id} data-testid={`tile-${g.id}`} onClick={() => ids[0] && setPage(ids[0])}
              style={{ ...S.navBtnReset, background:C.card, border:`1px solid ${C.border}`, borderRadius:10, padding:12, cursor:"pointer", textAlign:"left", transition:"transform 0.15s" }}
              onMouseEnter={e=>e.currentTarget.style.transform="scale(1.02)"} onMouseLeave={e=>e.currentTarget.style.transform="scale(1)"}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
                <span style={{ fontSize:22 }}>{g.icon}</span>
                {badge && <span style={S.badge(badge.color)}>{badge.n}</span>}
              </div>
              <div style={{ fontSize:13, fontWeight:600, color:C.txt, marginTop:8 }}>{g.label}</div>
              <div style={{ fontSize:10, color:C.muted }}>{ids.length} {plural(ids.length,"экран","экрана","экранов")}{folderCount ? ` · ${folderCount} ${plural(folderCount,"папка","папки","папок")}` : ""}</div>
            </button>
          );
        })}
      </div>

      {/* R114 §nav-IA Этап 2: избранное + недавние (быстрый возврат). Метки из реестра SCREENS. */}
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:18 }}>
        <div>
          <div style={{ fontSize:11, fontWeight:700, textTransform:"uppercase", letterSpacing:"0.07em", color:C.muted, marginBottom:8 }}>⭐ Избранное</div>
          {favList.length === 0 ? (
            <div style={{ fontSize:11, color:C.dim }}>Закрепите экран через ⭐ в поиске (Ctrl+K)</div>
          ) : (
            <div style={{ display:"flex", flexWrap:"wrap", gap:6 }}>
              {favList.map(p => (
                <button type="button" key={p} data-testid={`fav-${p}`} onClick={() => setPage(p)} style={chipStyle(C.txt)}>
                  <span>{SCREENS[p].icon}</span><span>{SCREENS[p].label}</span>
                </button>
              ))}
            </div>
          )}
        </div>
        <div>
          <div style={{ fontSize:11, fontWeight:700, textTransform:"uppercase", letterSpacing:"0.07em", color:C.muted, marginBottom:8 }}>🕘 Недавние</div>
          {recentList.length === 0 ? (
            <div style={{ fontSize:11, color:C.dim }}>Здесь появятся последние открытые экраны</div>
          ) : (
            <div style={{ display:"flex", flexWrap:"wrap", gap:6 }}>
              {recentList.map(p => (
                <button type="button" key={p} data-testid={`recent-${p}`} onClick={() => setPage(p)} style={chipStyle(C.muted)}>
                  <span>{SCREENS[p].icon}</span><span>{SCREENS[p].label}</span>
                </button>
              ))}
            </div>
          )}
        </div>
      </div>

      <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:12, marginBottom:20 }}>
        {[
          { v:totalHead, l:"Численность", c:C.accent, p:"employees" },
          { v:`${(totalFot/1e6).toFixed(1)}M`, l:"ФОТ / месяц", c:C.green, p:"payroll" },
          { v:`${(avgSalary/1e3).toFixed(0)}K`, l:"Ср. оклад", c:C.amber, p:"payslip" },
          { v:deptStats.length, l:"Подразделений", c:C.red, p:"staffing" },
        ].map((k,i) => (
          <div key={i} onClick={()=>setPage(k.p)} style={{...S.kpi(k.c),cursor:"pointer",transition:"transform 0.15s"}} onMouseEnter={e=>e.currentTarget.style.transform="scale(1.02)"} onMouseLeave={e=>e.currentTarget.style.transform="scale(1)"}>
            <div style={S.kpiVal(k.c)}>{k.v}</div>
            <div style={S.kpiLabel}>{k.l}</div>
          </div>
        ))}
      </div>

      {/* §8.1-B «Мои задачи» — единая очередь действий (Workday Inbox / SAP To-Do) */}
      {tasks && (() => {
        const total = tasks.approvals + tasks.failedRuns + tasks.overduePeriods;
        const items = [
          { n: tasks.approvals,      l:"На согласование",       icon:"✅", c:C.accent, p:"workflow", param:null },
          { n: tasks.failedRuns,     l:"Расчёты с ошибками",     icon:"⚠️", c:C.red,    p:"payroll",  param: tasks.failedRunPeriodId },
          { n: tasks.overduePeriods, l:"Незакрытые периоды",     icon:"📅", c:C.amber,  p:"payroll",  param: tasks.overduePeriodId },
        ].filter(t => t.n > 0);
        return (
          <div style={{ ...S.card, marginBottom:20, borderLeft:`3px solid ${total>0 ? C.amber : C.green}` }}>
            <div style={{ fontSize:13, fontWeight:600, marginBottom: total>0?12:0, display:"flex", alignItems:"center", gap:8 }}>
              <span>📥 Мои задачи</span>
              <span style={S.badge(total>0 ? C.amber : C.green)}>{total>0 ? total : "✓ 0"}</span>
            </div>
            {total === 0 ? (
              <div style={{ fontSize:12, color:C.green }}>Нет активных задач — всё обработано.</div>
            ) : (
              <div style={{ display:"grid", gridTemplateColumns:`repeat(${items.length},1fr)`, gap:10 }}>
                {items.map((t,i) => (
                  <button type="button" key={i} data-testid={`task-${t.p}`} onClick={()=>setPage(t.p, t.param)}
                    style={{ ...S.navBtnReset, ...S.kpi(t.c), cursor:"pointer", display:"flex", alignItems:"center", gap:10, padding:"12px 14px", textAlign:"left" }}>
                    <span style={{ fontSize:20 }}>{t.icon}</span>
                    <span>
                      <span style={{ fontSize:18, fontWeight:700, color:t.c, fontFamily:M, display:"block" }}>{t.n}</span>
                      <span style={{ fontSize:11, color:C.muted }}>{t.l}</span>
                    </span>
                  </button>
                ))}
              </div>
            )}
          </div>
        );
      })()}

      <div style={S.card}>
        <div style={{ fontSize:13, fontWeight:600, marginBottom:14 }}>ФОТ по подразделениям</div>
        {deptStats.length === 0 ? (
          <EmptyState icon="🏢" title="Нет подразделений" sub="Создайте подразделения и назначьте сотрудников" />
        ) : deptStats.map(d => (
          <div key={d.name} style={{ display:"flex", alignItems:"center", gap:10, marginBottom:8 }}>
            <div style={{ width:180, fontSize:11, color:C.muted }}>{d.name}</div>
            <div style={{ flex:1, background:C.bg3, borderRadius:3, height:6 }}>
              <div style={S.bar(d.fot/maxFot*100, C.accent)} />
            </div>
            <div style={{ width:90, textAlign:"right", fontSize:11, fontFamily:M, color:C.txt }}>{(d.fot/1e3).toFixed(0)}K</div>
            <div style={{ width:30, textAlign:"right", fontSize:10, color:C.muted }}>{d.head}</div>
          </div>
        ))}
      </div>

      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:14 }}>
        <div style={S.card}>
          <div style={{ fontSize:13, fontWeight:600, marginBottom:12 }}>НК РК 2026 — ставки</div>
          <table style={S.table}><tbody>
            {[["ОПВ","10%","50 МЗП"],["ВОСМС","2%","20 МЗП"],["ИПН","10/15%","8500 МРП"],["СН","6%","min 14 МРП"],["СО","5%","7 МЗП"],["ООСМС","3%","40 МЗП"],["ОПВР","3.5%","50 МЗП"]].map(([n,r,c],i) => (
              <tr key={i}>
                <td style={{...S.td, fontWeight:600, width:80}}>{n}</td>
                <td style={{...S.td, fontFamily:M, color:C.accent}}>{r}</td>
                <td style={{...S.td, color:C.muted, fontSize:11}}>{c}</td>
              </tr>
            ))}
          </tbody></table>
          <div style={{ marginTop:8, fontSize:10, color:C.muted }}>МРП = {MRP.toLocaleString()}₸ · МЗП = {MZP.toLocaleString()}₸</div>
        </div>
        <div style={S.card}>
          <div style={{ fontSize:13, fontWeight:600, marginBottom:12 }}>Система · {demo ? "демо" : `v${version}`}</div>
          {demo ? (
            // §5.1: в demo метрики системы недоступны (нет /health) → честная плашка вместо прочерков «—»
            <div style={{ fontSize:12, color:C.muted, lineHeight:1.7 }}>
              Демо-режим. Метрики системы (модули, endpoints, тесты) отображаются при подключении к API.
              <div style={{ display:"flex", justifyContent:"space-between", padding:"5px 0", marginTop:8, borderTop:`1px solid ${C.border}22` }}>
                <span style={{ color:C.muted }}>Сотрудников (демо)</span>
                <span style={{ fontFamily:M, color:C.accent, fontWeight:600 }}>{totalHead}</span>
              </div>
            </div>
          ) : [
            ["Модули", system?.modules ?? "—"],
            ["REST endpoints", system?.endpoints ?? "—"],
            ["Таблицы БД", system?.tables ?? "—"],
            ["Unit-тесты", system?.tests ?? "—"],
            ["Активных сотрудников", totalHead],
            ["Docker", "Ready"],
          ].map(([l,v],i) => (
            <div key={i} style={{ display:"flex", justifyContent:"space-between", padding:"5px 0", borderBottom:`1px solid ${C.border}22`, fontSize:12 }}>
              <span style={{ color:C.muted }}>{l}</span>
              <span style={{ fontFamily:M, color:C.accent, fontWeight:600 }}>{v}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}





// ═══ APP ═════════════════════════════════════════════════════
// R74→R113 §nav-IA: 3-уровневая навигация (раздел→папка→экран) по образцу 1С:Предприятие.
// SCREENS — единственный источник правды о каждом экране (метка/иконка/тип объекта).
//   type: ref=справочник · doc=документ · reg=регистр/журнал · rep=отчёт · cor=корректировка · svc=сервис.
// NAV_GROUPS — разделы и папки; ссылается на экраны по id. Элемент папки:
//   "id"        — основной экран («дом» в этом разделе);
//   {ref:"id"}  — ССЫЛКА на экран, чей дом в другом разделе (как теги-подсистемы 1С;
//                 рендерится приглушённо со стрелкой ↗). Подсветка/breadcrumb — по id.
// Группы сворачиваются (navOpen в localStorage); папки — постоянные подзаголовки.
const SCREENS = {
  // — Главное —
  dashboard:          { icon:"📊", label:"Сводка",               type:"rep" },
  analytics:          { icon:"📈", label:"Аналитика",            type:"rep" },
  workflow:           { icon:"✅", label:"Согласования",          type:"doc" },
  onboarding:         { icon:"🚀", label:"Мастер настройки",      type:"svc" },
  // — Кадры —
  employees:          { icon:"👥", label:"Сотрудники",            type:"ref" },
  departments:        { icon:"🌳", label:"Подразделения",         type:"ref" },
  hrhistory:          { icon:"📜", label:"Кадр. история",         type:"doc" },
  contractExtension:  { icon:"📄", label:"Продление ТД",          type:"doc" },
  contractSuspension: { icon:"⏸️", label:"Приостановл. ТД",       type:"doc" },
  reinstatement:      { icon:"⚖️", label:"Восстановление",        type:"doc" },
  secondaryPosition:  { icon:"➕", label:"Совмещения",            type:"doc" },
  recruiting:         { icon:"🎯", label:"Рекрутинг",             type:"doc" },
  training:           { icon:"📚", label:"Обучение",              type:"doc" },
  performance:        { icon:"⭐", label:"Performance",           type:"doc" },
  attestation:        { icon:"📑", label:"Аттестация",            type:"doc" },
  kpiBonus:           { icon:"🎯", label:"KPI и бонусы",          type:"doc" },
  workExperience:     { icon:"📜", label:"Стажи",                 type:"ref" },
  incomingCert:       { icon:"📥", label:"Справки вход.",         type:"doc" },
  outgoingCert:       { icon:"📤", label:"Справки исход.",        type:"doc" },
  benefits:           { icon:"🎫", label:"Льготы",                type:"ref" },
  occSafety:          { icon:"🦺", label:"Охрана труда",          type:"doc" },
  // — Штатное расписание —
  staffingApproval:   { icon:"📜", label:"Утверждение ШР",        type:"doc" },
  initialStaffing:    { icon:"🗂️", label:"Нач. расстановка",      type:"doc" },
  staffing:           { icon:"📋", label:"Штат. (legacy)",        type:"ref" },
  grades:             { icon:"📐", label:"Грейды",                type:"ref" },
  qualGradeChange:    { icon:"🎖️", label:"Изм. разряда",          type:"doc" },
  workLocation:       { icon:"🏢", label:"Места работы",          type:"ref" },
  workplaceChange:    { icon:"📍", label:"Перемещения мест",      type:"doc" },
  // — Расчёт зарплаты —
  payroll:            { icon:"💰", label:"Расчёт ЗП",             type:"doc" },
  advance:            { icon:"💸", label:"Аванс",                 type:"doc" },
  timesheet:          { icon:"📋", label:"Табель",                type:"doc" },
  payrollDataInput:   { icon:"📊", label:"Данные расчёта",        type:"doc" },
  payslip:            { icon:"📄", label:"Расч. листок",          type:"rep" },
  accrualJournal:     { icon:"📒", label:"Журнал начислений",     type:"reg" },
  gpdJournal:         { icon:"📒", label:"Журнал ГПХ",            type:"reg" },
  correctionJournal:  { icon:"📒", label:"Журнал корректировок",  type:"reg" },
  hrJournal:          { icon:"📒", label:"Журнал кадровых",       type:"reg" },
  absenceJournal:     { icon:"📒", label:"Журнал отсутствий",     type:"reg" },
  plannedAccruals:    { icon:"➕", label:"Плановые начисл.",      type:"doc" },
  oneTimeAccrual:     { icon:"➕", label:"Разовые начисл.",       type:"doc" },
  salaryIndexation:   { icon:"📈", label:"Индексация ЗП",         type:"doc" },
  salaryDelayComp:    { icon:"⏰", label:"Задержка ЗП",           type:"doc" },
  materialAid:        { icon:"💝", label:"Матпомощь",             type:"doc" },
  bonuses:            { icon:"🏆", label:"Премии",                type:"doc" },
  prizeGift:          { icon:"🎁", label:"Призы / подарки",       type:"doc" },
  naturalIncome:      { icon:"🎁", label:"Натур. доход",          type:"doc" },
  dividends:          { icon:"💵", label:"Дивиденды",             type:"doc" },
  guardianPayment:    { icon:"🤝", label:"Выплаты опекунам",      type:"doc" },
  gpd:                { icon:"📝", label:"ГПД (подряд)",          type:"doc" },
  authorContract:     { icon:"✍️", label:"Авторский заказ",       type:"doc" },
  weekendHoliday:     { icon:"🗓️", label:"Работа в выходные",     type:"doc" },
  deductions:         { icon:"⚖️", label:"Удержания / Исп.листы", type:"doc" },
  paymentStatement:   { icon:"🧾", label:"Выплатные ведомости",   type:"reg" },
  depositedSalary:    { icon:"🔐", label:"Депонирование",         type:"doc" },
  // — Отсутствия —
  vacations:          { icon:"🏖️", label:"Отпуска",               type:"doc" },
  vacationSchedule:   { icon:"📅", label:"График отпусков",       type:"doc" },
  vacationReserve:    { icon:"📊", label:"Резервы отпусков",      type:"rep" },
  childcareLeave:     { icon:"🍼", label:"Уход за ребёнком",      type:"doc" },
  unpaidLeave:        { icon:"🚪", label:"Отпуск без сохр.",      type:"doc" },
  sickleave:          { icon:"🏥", label:"Больничные",            type:"doc" },
  downtime:           { icon:"⏸️", label:"Простой",               type:"doc" },
  absenceRecord:      { icon:"🚷", label:"Прогулы / неявки",      type:"doc" },
  trips:              { icon:"✈️", label:"Командировки",          type:"doc" },
  timeOffInLieu:      { icon:"🔄", label:"Отгулы",                type:"doc" },
  avgEarningsTransfer:{ icon:"📐", label:"Средний заработок",     type:"doc" },
  // — Налоги и отчётность —
  taxPayments:        { icon:"🧾", label:"Уплата налогов",        type:"doc" },
  fnoReporting:       { icon:"📄", label:"ФНО Отчётность",        type:"rep" },
  storno:             { icon:"↩️", label:"Сторно / перерасчёт",   type:"cor" },
  ipnRecalc:          { icon:"🧮", label:"Перерасчёт ИПН",        type:"cor" },
  ipnRefund:          { icon:"↪️", label:"Возврат ИПН",           type:"cor" },
  insuranceRecalc:    { icon:"🧮", label:"Перерасчёт взносов",    type:"cor" },
  contributionPenalty:{ icon:"⏱️", label:"Пени по взносам",       type:"cor" },
  gl:                 { icon:"📒", label:"Главная книга",         type:"reg" },
  personalAccount:    { icon:"📇", label:"Лицевой счёт",          type:"reg" },
  reconciliation:     { icon:"🔍", label:"Сверка с 1С",           type:"rep" },
  rates:              { icon:"📖", label:"Справочник ставок",      type:"ref" },
  rounding:           { icon:"🔢", label:"Округление",            type:"ref" },
  calendar:           { icon:"📅", label:"Календарь",             type:"ref" },
  loans:              { icon:"💳", label:"Займы",                 type:"doc" },
  onecsync:           { icon:"🔄", label:"1С Синхр.",             type:"svc" },
  ess:                { icon:"👤", label:"ESS Портал",            type:"svc" },
};

// R114 §nav-IA Этап 2: read-perm для role-фильтра (fail-open). Только УВЕРЕННЫЕ сопоставления
// (perm-код бэка явно соответствует домену экрана); экран без записи виден всем — не прячем без
// основания. admin/demo видят всё (см. canSee в App). Коды сверены с RequirePermissions бэка.
const SCREEN_PERMS = {
  employees:"employee.read", departments:"employee.read",
  hrhistory:"hr.read", contractExtension:"hr.read", contractSuspension:"hr.read",
  reinstatement:"hr.read", secondaryPosition:"hr.read", attestation:"hr.read",
  recruiting:"recruiting.read", training:"training.read", performance:"performance.read",
  kpiBonus:"kpi.read", benefits:"benefits.read", occSafety:"safety.read",
  grades:"grade.read", qualGradeChange:"grade.read", staffing:"staff.read",
  staffingApproval:"staff.read", initialStaffing:"staff.read",
  payroll:"payroll.read", advance:"payroll.read", payslip:"payroll.read", accrualJournal:"payroll.read",
  payrollDataInput:"payroll.read", timesheet:"timesheet.read",
  deductions:"employee-deduction.read", storno:"storno.read",
  vacations:"vacation.read", vacationSchedule:"vacation.read", vacationReserve:"vacation.read",
  sickleave:"sick_leave.read", trips:"trips.read",
  gl:"gl.read", analytics:"analytics.read", fnoReporting:"reports.read",
  loans:"loans.read", workflow:"workflow.read", onecsync:"import.read",
};

// Разделы → папки → экраны. "id" = основной экран; {ref:"id"} = ссылка (дом в др. разделе).
const NAV_GROUPS = [
  { id:"main", label:"Главное", icon:"🏠", defaultOpen:true, folders:[
    { items:["dashboard","analytics","workflow","onboarding"] },
  ]},
  { id:"hr", label:"Кадры", icon:"👥", defaultOpen:true, folders:[
    { label:"Справочники",            items:["employees","departments"] },
    { label:"Кадровые документы",     items:["hrJournal","hrhistory","contractExtension","contractSuspension","reinstatement","secondaryPosition"] },
    { label:"Развитие персонала",     items:["recruiting","training","performance","attestation","kpiBonus"] },
    { label:"Справки и охрана труда", items:["workExperience","incomingCert","outgoingCert","benefits","occSafety"] },
  ]},
  { id:"staffing", label:"Штатное расписание", icon:"📋", defaultOpen:false, folders:[
    { label:"Структура и штат",  items:["staffingApproval","initialStaffing","staffing",{ref:"departments"}] },
    { label:"Грейды и разряды",  items:["grades","qualGradeChange"] },
    { label:"Рабочие места",     items:["workLocation","workplaceChange"] },
  ]},
  { id:"payroll", label:"Расчёт зарплаты", icon:"💰", defaultOpen:true, folders:[
    { label:"Расчёт и табель",     items:["payroll","advance","timesheet","payrollDataInput","payslip"] },
    { label:"Под рукой",           items:[{ref:"employees"},{ref:"sickleave"},{ref:"calendar"},{ref:"rates"}] },
    { label:"Начисления",          items:["accrualJournal","plannedAccruals","oneTimeAccrual","salaryIndexation","salaryDelayComp","materialAid","bonuses","prizeGift"] },
    { label:"Прочие доходы",       items:["naturalIncome","dividends","guardianPayment"] },
    { label:"Договоры ГПХ",        items:["gpdJournal","gpd","authorContract","weekendHoliday"] },
    { label:"Удержания и выплаты", items:["deductions","paymentStatement","depositedSalary"] },
  ]},
  { id:"absences", label:"Отсутствия", icon:"🏖️", defaultOpen:false, folders:[
    { label:"Отпуска",               items:["absenceJournal","vacations","vacationSchedule","vacationReserve","childcareLeave","unpaidLeave"] },
    { label:"Болезни и простои",     items:["sickleave","downtime","absenceRecord"] },
    { label:"Командировки и отгулы", items:["trips","timeOffInLieu","avgEarningsTransfer"] },
  ]},
  { id:"taxes", label:"Налоги и отчётность", icon:"🧾", defaultOpen:false, folders:[
    { label:"Налоги и взносы",             items:["taxPayments","fnoReporting"] },
    { label:"Корректировки и перерасчёты", items:["correctionJournal","storno","ipnRecalc","ipnRefund","insuranceRecalc","contributionPenalty"] },
    { label:"Отчёты",                      items:["gl","personalAccount","reconciliation"] },
    { label:"Справочники",                 items:["rates","rounding","calendar","loans"] },
    { label:"Сервис и интеграции",         items:["onecsync","ess"] },
  ]},
];
// Хелперы навигации: id из элемента папки, признак ссылки, все экраны раздела.
const navItemId = it => typeof it === "string" ? it : it.ref;
const navItemIsRef = it => typeof it === "object" && it !== null && !!it.ref;
const navGroupScreenIds = g => (g.folders || []).flatMap(f => f.items.map(navItemId));
// Flat NAV (уникальные экраны) для поиска/breadcrumb — из реестра SCREENS.
const NAV = Object.entries(SCREENS).map(([id, m]) => ({ id, ...m }));

export default function App() {
  // R75 Phase 2c: F5 сохраняет route через window.location.hash (page-level).
  // R112 §8.1-A: object deep-link — hash может нести объект «#/employees/42».
  // Первый сегмент = page (роутинг 78 экранов, обратная совместимость), остаток =
  // routeParam (id объекта). Экран читает routeParam и открывает объект (карточку).
  const parseHash = () => {
    try {
      const raw = (window.location.hash || "").replace(/^#\/?/, "").trim();
      const slash = raw.indexOf("/");
      if (slash === -1) return { page: raw || "dashboard", param: null };
      return { page: raw.slice(0, slash) || "dashboard", param: raw.slice(slash + 1) || null };
    } catch { return { page: "dashboard", param: null }; }
  };
  const [page, setPageRaw] = useState(() => parseHash().page);
  const [routeParam, setRouteParam] = useState(() => parseHash().param);
  // setPage(newPage, param?) — param пишет object-id в URL; без param очищает (page-level).
  // R114 §nav-IA Этап 2: недавние/избранное (лаунчпад + Ctrl+K)
  const [navRecent, setNavRecent] = useState(getNavRecent);
  const [navFavs, setNavFavs] = useState(getNavFavorites);
  const toggleFav = useCallback(p => setNavFavs(toggleNavFavorite(p)), []);
  const setPage = useCallback((newPage, param = null) => {
    setPageRaw(newPage);
    setRouteParam(param);
    setNavRecent(pushNavRecent(newPage));
    try {
      // Don't trigger hashchange listener for our own update
      const newHash = "#/" + newPage + (param != null && param !== "" ? "/" + param : "");
      if (window.location.hash !== newHash) {
        history.replaceState(null, "", newHash);
      }
    } catch {}
  }, []);
  // Listen browser back/forward (page + object)
  useEffect(() => {
    const onHashChange = () => {
      const { page: p, param } = parseHash();
      setPageRaw(p);
      setRouteParam(param);
    };
    window.addEventListener("hashchange", onHashChange);
    return () => window.removeEventListener("hashchange", onHashChange);
  }, []);

  const [loggedIn, setLoggedIn] = useState(false);
  const [login, setLogin] = useState(DEMO_ENABLED ? "admin" : "");
  const [pass, setPass] = useState(DEMO_ENABLED ? "demo2026" : "");
  const [mode, setMode] = useState("demo"); // "demo" | "api"
  // R112: реальная версия/модули/endpoints в сайдбаре из /health (был хардкод «v2.1·100·618» — устарел).
  const [sysInfo, setSysInfo] = useState(null);
  useEffect(() => {
    if (mode !== "api") return;
    apiGet("/health").then(h => h && setSysInfo({ version: h.version, modules: h.stats?.modules, endpoints: h.stats?.endpoints })).catch(() => {});
  }, [mode]);
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [notifOpen, setNotifOpen] = useState(false);
  // R75 Phase 2f: tenant switcher для platform admin (JWT.tenantId === null)
  const [tenants, setTenants] = useState([]);
  const [actingTenant, setActingTenantState] = useState(getActingTenantId());
  const [branding, setBranding] = useState(null); // R161 #7: брендинг тенанта (logoUrl/brandColor)
  const me = loggedIn && mode === "api" ? getMe() : null;
  const isPlatformAdmin = !!(me && (me.tenantId === null || me.tenantId === undefined) && me.roles?.includes("admin"));
  // R114 §nav-IA Этап 2: role-фильтр (fail-open) — экран виден если: нет perm-требования,
  // admin, demo (нет me), у юзера пустой permissions, ИЛИ есть нужный perm. Лишнего не прячем.
  const isAdmin = !!me?.roles?.includes("admin");
  const canSee = p => !p || isAdmin || !me || !(me.permissions && me.permissions.length) || me.permissions.includes(p);
  useEffect(() => {
    if (!isPlatformAdmin) return;
    apiGet("/tenants").then(setTenants).catch(() => setTenants([]));
  }, [isPlatformAdmin]);
  // R161 #7 (аудит R160): подтянуть брендинг текущего тенанта (логотип/цвет). Раньше
  // logoUrl/brandColor в БД были, но фронт их НЕ читал. Применяется ПОСЛЕ входа (на логине
  // тенант ещё неизвестен). tenant-изоляция пропускает GET своего тенанта. Дедуп по
  // me?.tenantId (примитив) — getMe() даёт новый объект каждый рендер, иначе цикл.
  useEffect(() => {
    if (mode !== "api") { setBranding(null); return; }
    const tid = actingTenant || me?.tenantId;
    if (!tid) { setBranding(null); return; }
    apiGet(`/tenants/${tid}`)
      .then(t => setBranding(t ? { logoUrl: t.logoUrl || null, brandColor: t.brandColor || null, name: t.name || null } : null))
      .catch(() => setBranding(null));
  }, [mode, actingTenant, me?.tenantId]);
  const switchTenant = (id) => {
    setActingTenantId(id || null);
    setActingTenantState(id || null);
    // Force-reload to refetch tenant-scoped data on current screen
    window.location.reload();
  };
  // R74: navOpen — must be declared BEFORE any conditional early return (hook order)
  const [navOpen, setNavOpen] = useState(() => {
    // R113: merge defaults со stored — новые разделы (taxes) получают свой defaultOpen,
    // а мёртвые ключи старой структуры (reports) безвредно игнорируются.
    const defaults = NAV_GROUPS.reduce((acc, g) => ({ ...acc, [g.id]: g.defaultOpen }), {});
    try {
      const stored = JSON.parse(localStorage.getItem("nav_open") || "null");
      if (stored) return { ...defaults, ...stored };
    } catch {}
    return defaults;
  });
  useEffect(() => { try { localStorage.setItem("nav_open", JSON.stringify(navOpen)); } catch {} }, [navOpen]);
  // Эксклюзивный аккордеон: при переходе на экран авто-раскрываем его раздел и сворачиваем
  // остальные — иначе сайдбар разрастался (несколько разделов открыты разом, теряешься на
  // невысоких экранах). no-op, если раздел текущего экрана уже открыт (без лишних ре-рендеров).
  useEffect(() => {
    let gid = null;
    for (const g of NAV_GROUPS) {
      if ((g.folders || []).some(f => f.items.some(it => !navItemIsRef(it) && navItemId(it) === page))) { gid = g.id; break; }
    }
    if (!gid) return;
    setNavOpen(o => {
      // уже строго эксклюзивно открыт нужный раздел → ничего не делаем (без ре-рендера)
      const alreadyExclusive = NAV_GROUPS.every(g => !!o[g.id] === (g.id === gid));
      return alreadyExclusive ? o : NAV_GROUPS.reduce((acc, g) => ({ ...acc, [g.id]: g.id === gid }), {});
    });
  }, [page]);
  // §5.9: открыт ли off-canvas сайдбар на мобильном (на десктопе .open не влияет — @media только ≤768px)
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  // §8.1-B: колокольчик показывает РЕАЛЬНЫЕ события из тех же задач, что виджет Dashboard (общий useMyTasks).
  const myTasks = useMyTasks(mode === "api");
  const notifications = useMemo(() => {
    if (!myTasks) return [{ id:"demo", type:"info", text:"Уведомления появятся при подключении к API", time:"", read:true }];
    const ev = [];
    if (myTasks.approvals > 0)      ev.push({ id:"appr",    type:"warning", text:`Согласований в очереди: ${myTasks.approvals}`,     time:"сейчас", read:false, page:"workflow" });
    if (myTasks.failedRuns > 0)     ev.push({ id:"failed",  type:"warning", text:`Расчётов с ошибками: ${myTasks.failedRuns}`,        time:"сейчас", read:false, page:"payroll", param: myTasks.failedRunPeriodId });
    if (myTasks.overduePeriods > 0) ev.push({ id:"overdue", type:"warning", text:`Незакрытых периодов: ${myTasks.overduePeriods}`,    time:"сейчас", read:false, page:"payroll", param: myTasks.overduePeriodId });
    if (ev.length === 0)            ev.push({ id:"ok",      type:"success", text:"Активных задач нет — всё обработано",                time:"сейчас", read:true });
    return ev;
  }, [myTasks]);
  const unreadCount = notifications.filter(n => !n.read).length;
  // §8.2-E: быстрые ДЕЙСТВИЯ (глаголы) в Ctrl+K — не только навигация по экранам, но и команды
  // (Workday/SAP command palette). «Новый сотрудник» открывает форму через action-параметр #/employees/new.
  const quickCommands = [
    { label:"➕ Новый сотрудник", page:"employees", param:"new", desc:"Действие · открыть форму создания", action:true },
    { label:"🧮 Запустить расчёт ЗП", page:"payroll", param:null, desc:"Действие · перейти к расчёту", action:true },
    { label:"🏥 Создать больничный", page:"sickleave", param:null, desc:"Действие · больничные листы", action:true },
    { label:"🏖️ Оформить отпуск", page:"vacations", param:null, desc:"Действие · отпуска", action:true },
    { label:"📋 Заполнить табель", page:"timesheet", param:null, desc:"Действие · учёт рабочего времени", action:true },
    { label:"✅ Согласования", page:"workflow", param:null, desc:"Действие · очередь согласований", action:true },
    { label:"📄 Сформировать ФНО", page:"fnoReporting", param:null, desc:"Действие · налоговая отчётность", action:true },
  ];
  // R116 §nav-IA #3: список экранов для Ctrl+K генерируется из реестра SCREENS (единый
  // источник, не хардкод-дубль — раньше расходился с навигацией). desc = тип объекта + раздел.
  const SCREEN_TYPE_RU = { ref:"Справочник", doc:"Документ", reg:"Журнал", rep:"Отчёт", cor:"Корректировка", svc:"Сервис" };
  const sectionLabelOf = (pg) => {
    // только «дом» экрана (primary), не ссылка {ref} — иначе раздел берётся по первому вхождению-ссылке.
    for (const g of NAV_GROUPS) for (const f of (g.folders || [])) if (f.items.some(it => !navItemIsRef(it) && navItemId(it) === pg)) return g.label;
    return "";
  };
  const searchableScreens = Object.entries(SCREENS).map(([pg, m]) => ({
    label: m.label, page: pg,
    desc: [SCREEN_TYPE_RU[m.type], sectionLabelOf(pg)].filter(Boolean).join(" · "),
  }));
  // §8.2-E: действия первыми (приоритет команд), затем экраны
  const allSearchItems = [...quickCommands, ...searchableScreens];
  const filteredScreens = searchQuery ? allSearchItems.filter(s => (s.label+s.desc).toLowerCase().includes(searchQuery.toLowerCase())) : allSearchItems;
  // R114 §nav-IA Этап 2: избранное/недавние в Ctrl+K (когда строка пустая). Метки из SCREENS.
  const palFavs = (navFavs || []).filter(p => SCREENS[p] && canSee(SCREEN_PERMS[p]));
  const palRecent = (navRecent || []).filter(p => SCREENS[p] && canSee(SCREEN_PERMS[p]));
  const paletteChip = { ...S.navBtnReset, width:"auto", display:"inline-flex", alignItems:"center", gap:5, background:C.bg3, border:"1px solid "+C.border, borderRadius:14, padding:"4px 10px", fontSize:11, color:C.txt, cursor:"pointer" };
  useEffect(() => {
    const handler = (e) => { if ((e.ctrlKey || e.metaKey) && e.key === "k") { e.preventDefault(); setSearchOpen(o => !o); setSearchQuery(""); } if (e.key === "Escape") { setSearchOpen(false); setNotifOpen(false); } };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, []);
  const [loginError, setLoginError] = useState("");
  const [loginLoading, setLoginLoading] = useState(false);
  // H-R2-2 (Codex R2): 2FA step-up state
  const [mfaChallenge, setMfaChallenge] = useState(null);  // {token, enrollmentRequired}
  const [totpCode, setTotpCode] = useState("");

  const handleLogin = async () => {
    setLoginLoading(true);
    setLoginError("");
    const res = await apiLogin(login, pass);
    if (res && res.mfaRequired) {
      setMfaChallenge({ token: res.mfaChallengeToken, enrollmentRequired: res.mfaEnrollmentRequired });
      setLoginLoading(false);
      return;
    }
    if (res && res.accessToken) {
      setApiMode(true);
      setMode("api");
      setLoggedIn(true);
    } else {
      if (DEMO_ENABLED && ["admin","hr.manager","payroll.calc","payroll.approve","auditor"].includes(login) && pass === "demo2026") {
        setApiMode(false);
        setMode("demo");
        setLoggedIn(true);
      } else {
        setLoginError("Неверный логин или пароль");
      }
    }
    setLoginLoading(false);
  };

  const handleVerifyTotp = async () => {
    setLoginLoading(true);
    setLoginError("");
    try {
      const res = await apiVerifyTotp(mfaChallenge.token, totpCode);
      if (res && res.accessToken) {
        setApiMode(true);
        setMode("api");
        setLoggedIn(true);
        setMfaChallenge(null);
        setTotpCode("");
      } else {
        setLoginError("Не удалось подтвердить TOTP");
      }
    } catch (e) {
      setLoginError(e.message || "Ошибка TOTP");
    }
    setLoginLoading(false);
  };

  // Restore token from localStorage on mount
  useEffect(() => {
    const token = localStorage.getItem("payroll_token");
    if (token) { setApiMode(true); setMode("api"); setLoggedIn(true); }
    // Listen for logout event (401)
    const onLogout = () => { setLoggedIn(false); setMode("demo"); };
    window.addEventListener("payroll:logout", onLogout);
    return () => window.removeEventListener("payroll:logout", onLogout);
  }, []);

  // T-35: Global CSS reset — no white backgrounds anywhere
  useEffect(() => {
    const style = document.createElement("style");
    style.textContent = `
      * { box-sizing: border-box; }
      body { background: #0B1120; color: #F1F5F9; margin: 0; font-family: 'IBM Plex Sans', system-ui, sans-serif; }
      ::-webkit-scrollbar { width: 6px; height: 6px; }
      ::-webkit-scrollbar-track { background: #0B1120; }
      ::-webkit-scrollbar-thumb { background: #1E3A5F; border-radius: 3px; }
      input, select, textarea { background: #1F2937; color: #F1F5F9; border: 1px solid #1E3A5F; }
      @media print {
        body { background: white !important; color: black !important; }
        .sidebar, .app-sidebar, .no-print { display: none !important; }
        /* R75 Phase 2h: при печати документа (Т-3 и др.) изолируем только .print-doc */
        body:has(.print-doc) * { visibility: hidden !important; }
        body:has(.print-doc) .print-doc, body:has(.print-doc) .print-doc * { visibility: visible !important; }
        body:has(.print-doc) .print-doc { position: absolute !important; left: 0 !important; top: 0 !important; width: 100% !important; padding: 0 12mm !important; box-shadow: none !important; }
      }
      /* §5.9 ERP-аудит: мобильный off-canvas сайдбар (ESS/согласования с телефона). Десктоп не трогаем —
         @media применяется только ≤768px; !important переопределяет инлайн S.* (инлайн > обычный CSS). */
      .app-hamburger { display: none; }
      @media (max-width: 768px) {
        .app-hamburger { display: inline-flex !important; }
        .app-sidebar {
          position: fixed !important; left: 0; top: 0; height: 100vh !important; z-index: 1100;
          transform: translateX(-100%); transition: transform 0.25s ease; box-shadow: 2px 0 16px rgba(0,0,0,0.5);
        }
        .app-sidebar.open { transform: translateX(0); }
        .app-main { padding: 14px !important; }
      }
    `;
    document.head.appendChild(style);
    return () => style.remove();
  }, []);

  if (!loggedIn) {
    // H-R2-2: 2FA TOTP screen если есть challenge
    if (mfaChallenge) {
      return (
        <div style={{ ...S.root, justifyContent:"center", alignItems:"center" }}>
          <div style={{ width:360, background:C.card, border:`1px solid ${C.border}`, borderRadius:12, padding:32 }}>
            <div style={{ fontSize:18, fontWeight:800, color:C.accent, textAlign:"center", marginBottom:4 }}>2FA</div>
            <div style={{ fontSize:11, color:C.muted, textAlign:"center", marginBottom:24 }}>
              {mfaChallenge.enrollmentRequired
                ? "Требуется первоначальная настройка 2FA"
                : "Введите 6-значный код из Google Authenticator"}
            </div>
            {mfaChallenge.enrollmentRequired ? (
              <div style={{ fontSize:11, color:C.amber, marginBottom:14, textAlign:"center" }}>
                Учётка требует первичной настройки 2FA. Войдите как admin для setup, или обратитесь к администратору.
              </div>
            ) : (
              <>
                <div style={{ marginBottom:20 }}>
                  <div style={{ fontSize:11, color:C.muted, marginBottom:4 }}>TOTP код</div>
                  <input style={S.input} value={totpCode} maxLength={6} placeholder="000000"
                    onChange={e => setTotpCode(e.target.value.replace(/\D/g, ""))}
                    onKeyDown={e => e.key === "Enter" && handleVerifyTotp()} />
                </div>
                {loginError && <div style={{ fontSize:11, color:C.red, marginBottom:10, textAlign:"center" }}>{loginError}</div>}
                <button style={{...S.btn(), width:"100%", padding:"10px 0", fontSize:14, opacity: loginLoading ? 0.6 : 1}}
                  onClick={handleVerifyTotp} disabled={loginLoading || totpCode.length !== 6}>
                  {loginLoading ? "⏳ Проверка..." : "Подтвердить"}
                </button>
              </>
            )}
            <button style={{...S.btn(C.bg3), width:"100%", padding:"6px 0", fontSize:11, marginTop:10}}
              onClick={() => { setMfaChallenge(null); setTotpCode(""); setLoginError(""); }}>
              ← Назад
            </button>
          </div>
        </div>
      );
    }
    return (
      <div style={{ ...S.root, justifyContent:"center", alignItems:"center" }}>
        <div style={{ width:360, background:C.card, border:`1px solid ${C.border}`, borderRadius:12, padding:32 }}>
          <div style={{ fontSize:18, fontWeight:800, color:C.accent, textAlign:"center", marginBottom:4 }}>PAYROLL ERP</div>
          <div style={{ fontSize:11, color:C.muted, textAlign:"center", marginBottom:24 }}>ЗУП+ для РК · НК РК 2026</div>
          <div style={{ marginBottom:12 }}>
            <div style={{ fontSize:11, color:C.muted, marginBottom:4 }}>Логин</div>
            <input style={S.input} value={login} onChange={e => setLogin(e.target.value)} onKeyDown={e => e.key === "Enter" && handleLogin()} />
          </div>
          <div style={{ marginBottom:20 }}>
            <div style={{ fontSize:11, color:C.muted, marginBottom:4 }}>Пароль</div>
            <input style={S.input} type="password" value={pass} onChange={e => setPass(e.target.value)} onKeyDown={e => e.key === "Enter" && handleLogin()} />
          </div>
          {loginError && <div style={{ fontSize:11, color:C.red, marginBottom:10, textAlign:"center" }}>{loginError}</div>}
          <button style={{...S.btn(), width:"100%", padding:"10px 0", fontSize:14, opacity: loginLoading ? 0.6 : 1}} onClick={handleLogin} disabled={loginLoading}>
            {loginLoading ? "⏳ Подключение..." : "Войти"}
          </button>
          {DEMO_ENABLED && (
            <div style={{ fontSize:10, color:C.muted, textAlign:"center", marginTop:16 }}>
              Демо-доступ: admin · hr.manager · payroll.calc · payroll.approve · auditor<br/>
              Пароль: demo2026<br/>
              <span style={{ color:C.dim }}>Демо-режим (API недоступен)</span>
            </div>
          )}
        </div>
      </div>
    );
  }

  // navOpen state declared earlier (above first conditional return) — hook order requirement.
  // эксклюзивно: раскрытие одного раздела сворачивает остальные (аккордеон)
  const toggleGroup = gid => setNavOpen(o => {
    const willOpen = !o[gid];
    return NAV_GROUPS.reduce((acc, g) => ({ ...acc, [g.id]: g.id === gid ? willOpen : false }), {});
  });

  return (
    <div style={S.root}>
      {/* §5.9 backdrop off-canvas сайдбара (только когда открыт; на десктопе hamburger скрыт → всегда false) */}
      {mobileNavOpen && <div onClick={() => setMobileNavOpen(false)} aria-hidden="true" style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.55)", zIndex:1090 }} />}
      <div className={`app-sidebar${mobileNavOpen ? " open" : ""}`} style={{...S.sidebar, overflowY:"auto"}}>
        <div style={{ ...S.logo, ...(branding?.brandColor ? { color: branding.brandColor } : {}) }} title={branding?.name || "PAYROLL ERP"}>
          {branding?.logoUrl
            ? <img src={branding.logoUrl} alt={branding.name || "PAYROLL ERP"} style={{ maxHeight:34, maxWidth:170, objectFit:"contain", display:"block", margin:"0 auto" }} />
            : (branding?.name || "PAYROLL ERP")}
        </div>
        <nav aria-label="Основная навигация">
        {NAV_GROUPS.map(group => {
          const isOpen = navOpen[group.id];
          // R114: role-фильтр (fail-open) — оставляем доступные экраны; пустые папки/разделы скрываем.
          const visFolders = (group.folders || [])
            .map(f => ({ ...f, items: f.items.filter(it => canSee(SCREEN_PERMS[navItemId(it)])) }))
            .filter(f => f.items.length > 0);
          if (visFolders.length === 0) return null;
          const containsActive = visFolders.some(f => f.items.some(it => navItemId(it) === page));
          return (
            <div key={group.id}>
              <button type="button" aria-expanded={isOpen} aria-controls={`navgroup-${group.id}`}
                data-testid={`navgroup-${group.id}`} onClick={() => toggleGroup(group.id)} style={{
                ...S.navBtnReset,
                padding:"8px 16px", fontSize:10, fontWeight:700, letterSpacing:"0.06em",
                color: containsActive ? C.accent : C.muted, textTransform:"uppercase", cursor:"pointer",
                display:"flex", alignItems:"center", justifyContent:"space-between",
                background: containsActive ? `${C.accent}08` : "transparent",
                borderTop:`1px solid ${C.border}30`, userSelect:"none", textAlign:"left",
              }}>
                <span style={{ display:"flex", alignItems:"center", gap:8 }}>
                  <span style={{ fontSize:12 }}>{group.icon}</span>
                  <span>{group.label}</span>
                </span>
                <span style={{ fontSize:10, color:C.muted }}>{isOpen ? "▼" : "▶"}</span>
              </button>
              {isOpen && (
                <div id={`navgroup-${group.id}`} role="group" aria-label={group.label}>
                  {visFolders.map((folder, fi) => (
                    <div key={folder.label || `f${fi}`}>
                      {/* R113: папка-подзаголовок (некликабельная, как панель навигации 1С). */}
                      {folder.label && (
                        <div style={{ padding:"8px 16px 3px", fontSize:10, fontWeight:700, letterSpacing:"0.07em", textTransform:"uppercase", color:C.muted, display:"flex", alignItems:"center", gap:5, opacity:0.85 }}>
                          <span style={{ fontSize:11 }}>📁</span><span>{folder.label}</span>
                        </div>
                      )}
                      {folder.items.map(it => {
                        const id = navItemId(it);
                        const isRef = navItemIsRef(it);
                        const scr = SCREENS[id];
                        if (!scr) return null;
                        return (
                          <button type="button" key={(isRef ? "ref-" : "") + id} data-testid={`nav-${isRef ? "ref-" : ""}${id}`}
                            aria-current={page===id ? "page" : undefined} onClick={() => { setPage(id); setMobileNavOpen(false); }}
                            style={{...S.navBtnReset, ...S.navItem(page===id), paddingLeft:28, ...(isRef ? { fontStyle:"italic" } : {})}}>
                            <span style={{ fontSize:13 }}>{scr.icon}</span>
                            <span>{scr.label}</span>
                            {/* ссылка на экран из другого раздела (дом там) */}
                            {isRef && <span title="Ссылка — экран находится в другом разделе" aria-hidden="true" style={{ marginLeft:"auto", fontSize:11, color:C.dim }}>↗</span>}
                          </button>
                        );
                      })}
                    </div>
                  ))}
                </div>
              )}
            </div>
          );
        })}
        </nav>
        <div style={{ marginTop:"auto", padding:"12px 16px", borderTop:`1px solid ${C.border}` }}>
          <div style={{ display:"flex", alignItems:"center", gap:6, marginBottom:6 }}>
            <div style={{ width:8, height:8, borderRadius:"50%", background: mode === "api" ? C.green : C.amber }} />
            <span style={{ fontSize:10, color: mode === "api" ? C.green : C.amber }}>{mode === "api" ? "Подключено к API" : "Демо-режим"}</span>
          </div>
          <div style={{ fontSize:10, color:C.dim, marginBottom:8 }}>{sysInfo ? `v${sysInfo.version} · ${sysInfo.modules} модулей · ${sysInfo.endpoints} EP` : (mode === "api" ? "—" : "demo")}</div>
              <button type="button" data-testid="btn-logout" aria-label="Выйти из системы" onClick={() => { localStorage.removeItem("payroll_token"); localStorage.removeItem("payroll_refresh"); setApiMode(false); setLoggedIn(false); setMode("demo"); }} style={{ background:"transparent", border:`1px solid ${C.border}`, borderRadius:6, padding:"6px 12px", fontSize:11, color:C.red, cursor:"pointer", width:"100%", display:"flex", alignItems:"center", justifyContent:"center", gap:6 }}>🚪 Выйти</button>
        </div>
      </div>
      <div className="app-main" style={S.main}>
            {/* T-41: Header bar with API mode + T-59: Breadcrumbs */}
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:16, paddingBottom:12, borderBottom:`1px solid ${C.border}` }}>
              <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                {/* §5.9 hamburger — открывает off-canvas сайдбар; .app-hamburger display:none на десктопе, flex ≤768px */}
                <button type="button" className="app-hamburger" aria-label="Открыть меню" data-testid="btn-hamburger" onClick={() => setMobileNavOpen(true)} style={{ background:"transparent", border:"none", color:C.txt, fontSize:20, cursor:"pointer", padding:"0 8px 0 0", lineHeight:1, alignItems:"center" }}>☰</button>
                {/* §8.2-F: кликабельные хлебные крошки как путь (Dashboard › Экран › #объект).
                    Dashboard всегда ведёт домой; при deep-link (routeParam) экран-сегмент сбрасывает объект. */}
                <button type="button" data-testid="crumb-dashboard" onClick={()=>setPage("dashboard")}
                  style={{ background:"transparent", border:"none", padding:0, fontSize:12, color:C.muted, cursor:"pointer", fontFamily:"inherit" }}>Сводка</button>
                {page !== "dashboard" && (() => {
                  const label = NAV.find(n=>n.id===page)?.label || page;
                  const crumbBtn = { background:"transparent", border:"none", padding:0, fontSize:12, color:C.muted, cursor:"pointer", fontFamily:"inherit" };
                  return routeParam ? (
                    <>
                      <span style={{ color:C.dim }}>›</span>
                      <button type="button" data-testid="crumb-page" onClick={()=>setPage(page)} style={crumbBtn}>{label}</button>
                      <span style={{ color:C.dim }}>›</span>
                      <span style={{ fontSize:12, color:C.txt }}>#{routeParam}</span>
                    </>
                  ) : (
                    <><span style={{ color:C.dim }}>›</span><span style={{ fontSize:12, color:C.txt }}>{label}</span></>
                  );
                })()}
              </div>
              <div style={{ display:"flex", alignItems:"center", gap:12 }}>
                <div style={{display:"flex",alignItems:"center",gap:10}}>
                <div role="button" tabIndex={0} aria-label="Поиск (Ctrl+K)" data-testid="btn-search" onClick={()=>{setSearchOpen(true);setSearchQuery("")}} onKeyDown={e=>{if(e.key==="Enter"||e.key===" "){e.preventDefault();setSearchOpen(true);setSearchQuery("")}}} style={{display:"flex",alignItems:"center",gap:6,padding:"4px 12px",borderRadius:6,background:C.bg3,border:"1px solid "+C.border+"40",cursor:"pointer",fontSize:12,color:C.muted,minWidth:180}}>
                  <span>&#128269;</span> <span>Поиск...</span> <span style={{marginLeft:"auto",fontSize:10,padding:"1px 6px",borderRadius:3,background:C.bg,border:"1px solid "+C.border+"40"}}>Ctrl+K</span>
                </div>
                <div role="button" tabIndex={0} aria-label="Уведомления" aria-expanded={notifOpen} data-testid="btn-notifications" onClick={()=>setNotifOpen(!notifOpen)} onKeyDown={e=>{if(e.key==="Enter"||e.key===" "){e.preventDefault();setNotifOpen(!notifOpen)}}} style={{position:"relative",cursor:"pointer",padding:6}}>
                  <span style={{fontSize:18}}>&#128276;</span>
                  {unreadCount > 0 && <div style={{position:"absolute",top:2,right:2,width:14,height:14,borderRadius:"50%",background:"#EF4444",color:"white",fontSize:8,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800}}>{unreadCount}</div>}
                  {notifOpen && <div style={{position:"absolute",top:36,right:0,width:320,background:C.card,border:"1px solid "+C.border,borderRadius:8,boxShadow:"0 8px 32px rgba(0,0,0,0.4)",zIndex:1000,overflow:"hidden"}} onClick={e=>e.stopPropagation()}>
                    <div style={{padding:"10px 14px",borderBottom:"1px solid "+C.border+"40",fontSize:13,fontWeight:700}}>Уведомления</div>
                    {notifications.map(n => <div key={n.id} data-testid={`notif-${n.id}`} onClick={n.page ? () => { setPage(n.page, n.param ?? null); setNotifOpen(false); } : undefined} style={{padding:"8px 14px",borderBottom:"1px solid "+C.border+"20",background:n.read?"transparent":C.accent+"08", cursor:n.page?"pointer":"default"}}>
                      <div style={{fontSize:12,fontWeight:n.read?400:600}}>{n.type==="success"?"\u2705":n.type==="warning"?"\u26A0\uFE0F":"\u2139\uFE0F"} {n.text}</div>
                      <div style={{fontSize:10,color:C.muted,marginTop:2}}>{n.time}</div>
                    </div>)}
                  </div>}
                </div>
              </div>
              {/* R75 Phase 2f: tenant switcher для platform admin */}
              {isPlatformAdmin && tenants.length > 0 && (
                <select value={actingTenant || ""}
                  onChange={e => switchTenant(e.target.value ? Number(e.target.value) : null)}
                  title={actingTenant ? "Действую от имени tenant'а — выберите 'Все tenants' чтобы вернуться в platform-admin режим" : "Platform-admin — выберите tenant для действий от его имени"}
                  style={{
                    padding:"4px 8px", borderRadius:6, fontSize:11,
                    background: actingTenant ? C.amber+"15" : C.bg3,
                    color: actingTenant ? C.amber : C.muted,
                    border: `1px solid ${actingTenant ? C.amber+"60" : C.border}`,
                    cursor:"pointer", outline:"none", maxWidth:220,
                  }}>
                  <option value="">🌐 Все tenants (platform)</option>
                  {tenants.map(t => (
                    <option key={t.id} value={t.id}>👤 #{t.id} · {t.name}</option>
                  ))}
                </select>
              )}
              <div style={{ display:"inline-flex", alignItems:"center", gap:4, padding:"3px 10px", borderRadius:12, fontSize:10, fontWeight:700, background: mode==="api" ? C.green+"20" : C.amber+"20", color: mode==="api" ? C.green : C.amber, border:`1px solid ${mode==="api" ? C.green : C.amber}40` }}>
                  <div style={{ width:6, height:6, borderRadius:"50%", background: mode==="api" ? C.green : C.amber }} />
                  {mode==="api" ? "API Live" : "Demo"}
                </div>
              </div>
            </div>
        {page === "dashboard" && <DashboardScreen setPage={setPage} canSee={canSee} navRecent={navRecent} navFavs={navFavs} toggleFav={toggleFav} />}
        <Suspense fallback={<div style={{ padding: 48, textAlign: "center", color: C.muted }}>Загрузка модуля…</div>}>
        {page === "employees" && <EmployeesScreen deepLinkId={routeParam} navigate={setPage} />}
        <ToastContainer />
      {searchOpen && <div style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,0.6)",zIndex:9999,display:"flex",alignItems:"flex-start",justifyContent:"center",paddingTop:100}} onClick={()=>setSearchOpen(false)}>
        <div style={{width:480,background:C.card,borderRadius:12,border:"1px solid "+C.border,boxShadow:"0 16px 64px rgba(0,0,0,0.5)",overflow:"hidden"}} onClick={e=>e.stopPropagation()}>
          <div style={{padding:"12px 16px",borderBottom:"1px solid "+C.border+"40"}}>
            <input autoFocus value={searchQuery} onChange={e=>setSearchQuery(e.target.value)} onKeyDown={e=>{if(e.key==="Enter"&&filteredScreens.length>0){setPage(filteredScreens[0].page,filteredScreens[0].param);setSearchOpen(false)}}} placeholder="Поиск экрана или действия... (Enter)" style={{width:"100%",padding:8,borderRadius:6,background:C.bg,color:C.text,border:"1px solid "+C.border,fontSize:14,outline:"none"}} />
          </div>
          <div style={{maxHeight:360,overflowY:"auto"}}>
            {/* R114: быстрый доступ — избранное/недавние когда строка поиска пустая */}
            {!searchQuery && (palFavs.length > 0 || palRecent.length > 0) && (
              <div style={{padding:"10px 16px",borderBottom:"1px solid "+C.border+"40"}}>
                {palFavs.length > 0 && (
                  <div style={{marginBottom: palRecent.length ? 10 : 0}}>
                    <div style={{fontSize:10,color:C.muted,textTransform:"uppercase",letterSpacing:"0.06em",marginBottom:6}}>⭐ Избранное</div>
                    <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
                      {palFavs.map(p => <button type="button" key={p} data-testid={`pal-fav-${p}`} onClick={()=>{setPage(p);setSearchOpen(false)}} style={paletteChip}><span>{SCREENS[p].icon}</span><span>{SCREENS[p].label}</span></button>)}
                    </div>
                  </div>
                )}
                {palRecent.length > 0 && (
                  <div>
                    <div style={{fontSize:10,color:C.muted,textTransform:"uppercase",letterSpacing:"0.06em",marginBottom:6}}>🕘 Недавние</div>
                    <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
                      {palRecent.map(p => <button type="button" key={p} data-testid={`pal-recent-${p}`} onClick={()=>{setPage(p);setSearchOpen(false)}} style={paletteChip}><span>{SCREENS[p].icon}</span><span>{SCREENS[p].label}</span></button>)}
                    </div>
                  </div>
                )}
              </div>
            )}
            {filteredScreens.map(s => <div key={(s.action?"a-":"s-")+s.page+(s.param||"")} data-testid={s.action?`cmd-${s.page}${s.param?"-"+s.param:""}`:undefined} onClick={()=>{setPage(s.page,s.param);setSearchOpen(false)}} style={{padding:"10px 16px",cursor:"pointer",borderBottom:"1px solid "+C.border+"20",display:"flex",justifyContent:"space-between",alignItems:"center"}} onMouseEnter={e=>e.currentTarget.style.background=C.accent+"10"} onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
              <div><div style={{fontSize:13,fontWeight:600}}>{s.label}</div><div style={{fontSize:11,color:C.muted}}>{s.desc}</div></div>
              {s.action ? <span style={{fontSize:10,color:C.accent}}>⚡</span> : (
                <span role="button" tabIndex={0} data-testid={`pin-${s.page}`} title={(navFavs||[]).includes(s.page)?"Убрать из избранного":"В избранное"}
                  onClick={e=>{e.stopPropagation();toggleFav(s.page)}} onKeyDown={e=>{if(e.key==="Enter"||e.key===" "){e.preventDefault();e.stopPropagation();toggleFav(s.page)}}}
                  style={{fontSize:14,cursor:"pointer",color:(navFavs||[]).includes(s.page)?C.amber:C.dim,padding:"0 2px"}}>{(navFavs||[]).includes(s.page)?"★":"☆"}</span>
              )}
            </div>)}
            {filteredScreens.length===0 && <div style={{padding:20,textAlign:"center",color:C.muted}}>Ничего не найдено</div>}
          </div>
        </div>
      </div>}
        {page === "payroll" && <PayrollRunScreen deepLinkId={routeParam} navigate={setPage} />}
        {page === "payslip" && <PayslipScreen deepLinkId={routeParam} navigate={setPage} />}
        {page === "deductions" && <DeductionsScreen />}
        {page === "accrualJournal" && <AccrualJournalScreen navigate={setPage} />}
        {page === "gpdJournal" && <GpdJournalScreen navigate={setPage} />}
        {page === "correctionJournal" && <CorrectionJournalScreen navigate={setPage} />}
        {page === "hrJournal" && <HrJournalScreen navigate={setPage} />}
        {page === "absenceJournal" && <AbsenceJournalScreen navigate={setPage} />}
        {page === "plannedAccruals" && <PlannedAccrualChangeScreen />}
        {page === "salaryIndexation" && <SalaryIndexationScreen />}
        {page === "salaryDelayComp" && <SalaryDelayCompensationScreen />}
        {page === "qualGradeChange" && <QualificationGradeChangeScreen />}
        {page === "downtime" && <DowntimeScreen />}
        {page === "taxPayments" && <TaxPaymentScreen />}
        {page === "contractExtension" && <ContractExtensionScreen />}
        {page === "materialAid" && <MaterialAidScreen />}
        {page === "naturalIncome" && <NaturalIncomeScreen />}
        {page === "dividends" && <DividendPaymentScreen />}
        {page === "bonuses" && <BonusPaymentScreen />}
        {page === "depositedSalary" && <DepositedSalaryScreen />}
        {page === "timesheet" && <TimesheetScreen />}
        {page === "vacations" && <VacationScreen />}
        {page === "sickleave" && <SickLeaveScreen />}
        {page === "workflow" && <WorkflowScreen />}
        {page === "hrhistory" && <HrHistoryScreen />}
        {page === "trips" && <TripsScreen />}
        {page === "grades" && <StaffGradeScreen />}
        {page === "staffing" && <StaffScheduleScreen />}
        {page === "calendar" && <CalendarScreen />}
        {page === "rates" && <ReferenceRatesScreen />}
        {page === "rounding" && <RoundingRulesScreen />}
        {page === "gl" && <GlLedgerScreen />}
        {page === "storno" && <StornoScreen />}
        {page === "gpd" && <GpdContractScreen />}
        {page === "vacationReserve" && <VacationReserveScreen />}
        {page === "reinstatement" && <ReinstatementScreen />}
        {page === "contractSuspension" && <ContractSuspensionScreen />}
        {page === "vacationSchedule" && <VacationScheduleScreen />}
        {page === "authorContract" && <AuthorContractScreen />}
        {page === "weekendHoliday" && <WeekendHolidayWorkScreen />}
        {page === "secondaryPosition" && <SecondaryPositionScreen />}
        {page === "childcareLeave" && <ChildcareLeaveScreen />}
        {page === "unpaidLeave" && <UnpaidLeaveScreen />}
        {page === "oneTimeAccrual" && <OneTimeAccrualScreen />}
        {page === "prizeGift" && <PrizeGiftScreen />}
        {page === "paymentStatement" && <PaymentStatementScreen />}
        {page === "ipnRecalc" && <IpnRecalculationScreen />}
        {page === "ipnRefund" && <IpnRefundScreen />}
        {page === "insuranceRecalc" && <InsuranceRecalcScreen />}
        {page === "contributionPenalty" && <ContributionPenaltyScreen />}
        {page === "guardianPayment" && <GuardianPaymentScreen />}
        {page === "avgEarningsTransfer" && <AvgEarningsTransferScreen />}
        {page === "absenceRecord" && <AbsenceRecordScreen />}
        {page === "timeOffInLieu" && <TimeOffInLieuScreen />}
        {page === "incomingCert" && <IncomingEarningCertScreen />}
        {page === "outgoingCert" && <OutgoingEarningCertScreen />}
        {page === "occSafety" && <OccSafetyScreen />}
        {page === "benefits" && <BenefitsScreen />}
        {page === "kpiBonus" && <KpiBonusScreen />}
        {page === "advance" && <AdvanceScreen />}
        {page === "personalAccount" && <PersonalAccountScreen />}
        {page === "reconciliation" && <ReconciliationScreen />}
        {page === "loans" && <LoansScreen />}
        {page === "training" && <TrainingScreen />}
        {page === "performance" && <PerformanceScreen />}
        {page === "recruiting" && <RecruitingScreen />}
        {page === "ess" && <EssScreen />}
        {page === "onecsync" && <OneCSyncScreen />}
      {page === "analytics" && <AnalyticsDashboardScreen />}
      {page === "fnoReporting" && <FnoReportingScreen />}
      {/* R65-R71 new module routes */}
      {page === "staffingApproval" && <StaffingApprovalScreen />}
      {page === "initialStaffing" && <InitialStaffingAssignmentScreen />}
      {page === "workLocation" && <WorkLocationScreen />}
      {page === "workplaceChange" && <WorkplaceChangeScreen />}
      {page === "workExperience" && <WorkExperienceScreen />}
      {page === "attestation" && <AttestationScreen />}
      {page === "payrollDataInput" && <PayrollDataInputScreen />}
      {/* R74 new screens */}
      {page === "departments" && <DepartmentsTreeScreen setPage={setPage} />}
      {/* R75 Phase 2i onboarding wizard */}
      {page === "onboarding" && <OnboardingWizardScreen setPage={setPage} />}
      </Suspense>
      </div>
    </div>
  );
}

